import React, { Component } from 'react';
import { withRouter } from '../ganchos/withRouter';
import { createSearchParams, Navigate } from 'react-router';
import UtilService from '../service/UtilService';

class PaginaNaoExiste extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /*
     console.log(this.props);
        const url = "/" + this.props.params["*"];
        const searchParams = UtilService.getAllParams();
        searchParams.url = url
        const search = "?" + createSearchParams(searchParams).toString();
        console.log("Rota não encontrada", url, search);
        return this.props.navigate({
            pathname: "/login",
            search
        });
    */
   
    render() {
      
        return (
            <>
                <Navigate to={{ pathname: "/dashboard" }} ></Navigate>
                <p></p>
            </>
        )
    }
}
export default withRouter(PaginaNaoExiste);